/*
 * @Author: yaoyuting
 * @Date: 2021-04-23 17:17:07
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-05-27 18:57:01
 * @Descripttion:
 */
import {
  get, gets, post, posts,
} from './server.js';
//  注册
export const Registered = p => post('/donet/system/user/registered', p);
// 登录
export const Login = p => post('/donet/system/webLogin', p);
// 忘记密码
export const UpdatePwd = p => post('/donet/system/user/updatePwd', p);
// 验证码
// export const WebLogout = p => get('/donet/system/user/emailVerification', p);
// 是否绑定钱包
export const CheckUsersStatus = p => post(`/donet/system/user/checkUsersStatus`,p);
// 获取账户地址-个人信息展示用
export const GetUsersAddress = p => post(`/donet/system/user/getUsersAddress`,p);
// // 绑定钱包
// export const BindWallet = p => post('/system/user/bindWallet', p);
// // 获取登录图片
// export const GetCaptchaImage = p => gets('/system/captcha/captchaImage?type=char', p);
// // 主网数据概览
// export const GetProjectOutcome = p => get('/system/getProjectOutcome', p);
// 核心成员
export const GetPartnerList = p => post('/donet/system/member/list', p);
// 官网博客列表
export const GetBlogList = p => post('/donet/system/blog/webList', p);
// 博客详情
export const GetBlogDetail = id => get(`/donet/system/blog/webDetail/${id}`);
// 订阅
// export const SubBlog = (blogId,email )=> get(`/donet/system/blog/subBlog/${blogId}/${email}`);

export const SubBlog = blogId => get(`/donet/system/blog/subBlog/${blogId}`);
// 邮箱验证码
export const GetEmail = p => post(`/transformers/system/activity/subscribe`,p);
//资金申请
export const GetUpdate = p => post(`/transformers/system/fund/add`,p);
//图片上传
export const GetImgpdate = p => post(`/transformers/common/imgUpdate`,p);
//合约
export const GetcommitApply = p => post(`/transformers/system/invest/commitApply`,p);
// https://tfsc.io/transformers/system/ambassador/commitApply
//流量大使
export const Getcommitambassador = p => post(`/transformers/system/ambassador/commitApply`,p);
export const base = 'http://3.19.158.80:9200'//测试
export const commitFund = p => post(base +`/transformers/system/fundRaising/commitFund`,p);
//export const base1 = 'http://192.168.1.123:8082'//测试
export const base1 = 'https://www.tfsc.io'//测试
//https://www.tfsc.io/botURL/bindNewAddress 正式环境请求
export const getbindNewAddress = p => post(base1 +`/botURL/bindNewAddress`,p);
// export const base2 = 'http://192.168.1.123'//测试
export const base2 = 'https://www.tfsc.io'//测试